/**
 * Events Feed
 * -----------------------------------------------------------------------------
 */

// Imports.
const $          = require( 'jquery' );
const MediaQuery = require( 'und:media-query' );
const throttle   = require( 'und:throttle' );



/**
 * Notes
 * 1. Converting jQuery collection of elements to an array of jQuery objects
 *    (from those elements).
 */
function EventsFeed() {

  const NAMESPACE    = '.und.events-feed';
  const $eventsFeeds = $( '.events-feed' ).map( ( i, el ) => $( el ) ); /* 1 */



  /**
   * Initialize accessible-slick.
   * 
   * @param {jQuery} $el Snippet container element. This is not the element
   *                     that accessible-slick is applied to.
   */
  function init( $el ) {
    
    const $sliderContainer = $el.find( '.events-feed__slides' );

    toggleSlick( $sliderContainer ); 

    $( window ).on( `resize${NAMESPACE}`, throttle( function () {
      toggleSlick( $sliderContainer );
    }, 250 ) );

  }

  /**
   * Toggles accessible-slick slider on or off. 
   * 
   * @param {jQuery} $container The object representing the container element 
   *                            that accessible-slick is applied to.
   */
  function toggleSlick( $container ) {  

    if ( MediaQuery.atLeast( 'sm' ) ) {

      if ( $container.hasClass( 'slick-initialized' ) ) {
        $container.slick( 'unslick' ); // Destroy Slick
      }

    } else {

      if ( !$container.hasClass( 'slick-initialized' ) ) {

        $container.slick( {
          labelPrevArrow: 'Previous Event',
          labelNextArrow: 'Next Event'
        } );

      }

    }

  }



  // Setup Events Feed slider.
  if ( !$eventsFeeds.length ) {
    return;
  }

  import( 'accessible_slick_script' )
    .then( ( res ) => {

      MediaQuery._init();
      $eventsFeeds.map( ( i, $el ) => init( $el ) );

    } )
    .catch( ( e ) => console.log( e ) );

}



EventsFeed();